// メニューを開く関数
const slideDown = (el) => {
  el.style.height = 'auto' //いったんautoに
  let h = el.offsetHeight //autoにした要素から高さを取得
  el.style.height = h + 'px'
  el.animate(
    [
      //高さ0から取得した高さまでのアニメーション
      { height: 0 },
      { height: h + 'px' },
    ],
    {
      duration: 300, //アニメーションの時間（ms）
    }
  )
}

// メニューを閉じる関数
const slideUp = (el) => {
  el.style.height = 0
}

let activeIndex = null //開いているアコーディオンのindex

//アコーディオンコンテナ全てで実行
const accordions = document.querySelectorAll('ul.include-accordion')

accordions.forEach((accordion) => {
  const accordionBtns = accordion.querySelectorAll('.accordionBtn')

  accordionBtns.forEach((accordionBtn) => {
    accordionBtn.addEventListener('click', (e) => {
      const currentItem = accordionBtn.parentNode
      const currentContent = accordionBtn.nextElementSibling
      const isActive = currentItem.classList.contains('active')

      // 一旦すべて閉じる
      accordionBtns.forEach((btn) => {
        btn.parentNode.classList.remove('active')
        slideUp(btn.nextElementSibling)
      })

      // 今回クリックされたものだけ開く（元々開いていたら開かない）
      if (!isActive) {
        currentItem.classList.add('active')
        slideDown(currentContent)
      }

      // 親のスクロール制御
      const container = accordion.closest('.scroll-control')
      if (container) {
        if (currentItem.classList.contains('active')) {
          container.classList.add('active')
        } else {
          container.classList.remove('active')
        }
      }
    })
  })
})
// スマホナビ
const initializeDetailsAccordion = (details) => {
  const summary = details.querySelector('summary')
  const panel = details.querySelector('summary + *')

  if (!(details && summary && panel)) return // 必要要素が揃ってない場合は処理をやめる

  let isTransitioning = false // 連打防止フラグ

  const onOpen = () => {
    if (details.open || isTransitioning) {
      return
    }
    isTransitioning = true
    panel.style.gridTemplateRows = '0fr'
    details.setAttribute('open', '')
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.gridTemplateRows = '1fr'
      })
    })
    panel.addEventListener(
      'transitionend',
      () => {
        isTransitioning = false
      },
      { once: true }
    )
  }

  const onClose = () => {
    if (!details.open || isTransitioning) {
      return
    }
    isTransitioning = true
    panel.style.gridTemplateRows = '0fr'
    panel.addEventListener(
      'transitionend',
      () => {
        details.removeAttribute('open')
        panel.style.gridTemplateRows = ''
        isTransitioning = false
      },
      { once: true }
    )
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault()
    if (details.open) {
      onClose()
    } else {
      onOpen()
    }
  })
}
// Use
const accordion = document.querySelectorAll('js_accordion')
initializeDetailsAccordion(accordion)
